(function (window, document) {
  'use strict';

  if (window.nzsOverlay && window.nzsOverlay.enhance) return;

  /* NZS-JUMP-SPY (gated): add ?nzsdebug=1 to any URL to show an on-screen readout of
     whatever triggers a scroll jump-to-top (for the intermittent mobile bug). No effect
     unless the param is present. */
  try {
    if (!window.__nzsScrollSpy2 && location.search.indexOf('nzsdebug') !== -1) {
      var _box = document.createElement('div');
      _box.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;background:rgba(0,0,0,.86);color:#3f6;font:11px/1.35 monospace;padding:6px 8px;max-height:40vh;overflow:auto;white-space:pre-wrap';
      var _log = function (m) { _box.textContent = ('' + Date.now()).slice(-6) + '  ' + m + '\n' + _box.textContent; };
      var _mount = function () { (document.body || document.documentElement).appendChild(_box); _log('nzsdebug spy on'); };
      if (document.body) _mount(); else document.addEventListener('DOMContentLoaded', _mount);
      var _lastY = 0;
      window.addEventListener('scroll', function () {
        var n = window.scrollY || 0;
        if (_lastY > 500 && n < 60) _log('JUMP ' + Math.round(_lastY) + '->' + n + '  lastTop:' + (window.__nzsLastTop || '?'));
        _lastY = n;
      }, { passive: true });
      var _oST = window.scrollTo.bind(window);
      window.scrollTo = function (a, b) {
        var y = (a && typeof a === 'object') ? a.top : b;
        if (y != null && y < 60) { window.__nzsLastTop = ((new Error()).stack || '').split('\n').slice(2, 5).join(' | ').replace(/https?:\/\/[^ )]+\//g, ''); _log('scrollTo(' + y + ')  ' + window.__nzsLastTop); }
        return _oST(a, b);
      };
      var _oSIV = Element.prototype.scrollIntoView;
      Element.prototype.scrollIntoView = function () { _log('SIV ' + ((this.className && ('' + this.className).slice(0, 26)) || this.tagName)); return _oSIV.apply(this, arguments); };
    }
  } catch (_e) {}

  var FOCUSABLE = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'details > summary:first-of-type',
    'iframe',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
  ].join(',');
  var CAN_INERT = 'HTMLElement' in window && 'inert' in window.HTMLElement.prototype;

  /* Reference-counted, SHARED scroll lock. Overlays open/close in sequence
     (open() closes others first), so a per-instance fixed-body lock could run
     lockScroll() while the body was already position:fixed — capturing
     window.scrollY as 0, then restoring to 0 on close (the intermittent
     mid-page jump-to-top). One shared counter captures scrollY only on the
     first lock and restores it only after the last overlay unlocks. */
  var _lockN = 0, _lockY = 0, _lockBody = null;
  function acquireScrollLock() {
    if (_lockN === 0) {
      var s = document.body.style;
      if (s.position === 'fixed') {
        /* A non-shared lock already owns the body: ADOPT it. Don't re-style now and (via
           _lockBody null) don't restore styles or scrollTo on release — the foreign owner
           restores its own state. Capturing scrollY here would read the clamped 0 and a
           later restore would be the mid-page jump-to-top. */
        _lockBody = null;
        _lockY = /^-?\d/.test(s.top) ? Math.max(0, -parseFloat(s.top)) : 0;
        try { console.warn('[nzs-overlay] foreign body lock adopted:', s.top); } catch (e) {}
      } else {
        _lockY = Math.max(0, window.scrollY || window.pageYOffset || 0);
        _lockBody = { position: s.position, top: s.top, left: s.left, right: s.right, width: s.width };
        s.position = 'fixed'; s.top = '-' + _lockY + 'px'; s.left = '0'; s.right = '0'; s.width = '100%';
      }
    }
    _lockN++;
  }
  function releaseScrollLock() {
    if (_lockN === 0) return;
    _lockN--;
    if (_lockN === 0 && _lockBody) {
      var s = document.body.style;
      s.position = _lockBody.position; s.top = _lockBody.top; s.left = _lockBody.left;
      s.right = _lockBody.right; s.width = _lockBody.width;
      _lockBody = null;
      /* Force an INSTANT restore: if a global scroll-behavior:smooth is ever added,
         a smooth-animated restore would leave window.scrollY unsettled when the next
         overlay captures it (re-introducing the jump-to-top). */
      var de = document.documentElement, prevSB = de.style.scrollBehavior;
      de.style.scrollBehavior = 'auto';
      window.scrollTo(0, _lockY);
      de.style.scrollBehavior = prevSB;
    }
  }

  function isVisible(element) {
    return element.getClientRects().length > 0
      && window.getComputedStyle(element).visibility !== 'hidden'
      && !element.closest('[hidden],[aria-hidden="true"],[inert]');
  }

  function focusables(root) {
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (element) {
      return element.tabIndex >= 0 && isVisible(element);
    });
  }

  function focus(element) {
    if (!element || typeof element.focus !== 'function') return;
    try { element.focus({ preventScroll: true }); }
    catch (_) { element.focus(); }
  }

  function backgroundTargets() {
    var targets = [];
    var main = document.getElementById('MainContent') || document.querySelector('body > main');
    var footers = document.querySelectorAll('[class*="shopify-section-group-footer"]');
    if (main) targets.push(main);
    if (footers.length) {
      Array.prototype.forEach.call(footers, function (footer) {
        if (footer !== main) targets.push(footer);
      });
    } else {
      var footer = document.querySelector('body > footer');
      if (footer && footer !== main) targets.push(footer);
    }
    return targets;
  }

  function enhance(options) {
    options = options || {};
    var root = options.root;
    var trigger = options.trigger;
    var key = options.key;
    var onOpen = typeof options.onOpen === 'function' ? options.onOpen : function () {};
    var onClose = typeof options.onClose === 'function' ? options.onClose : function () {};
    var openState = false;
    var inerted = [];
    var locked = false;

    if (!root || !key) throw new Error('nzsOverlay.enhance requires root and key');

    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    if (options.label && !root.hasAttribute('aria-label')) {
      root.setAttribute('aria-label', options.label);
    }
    if (!root.hasAttribute('tabindex')) root.setAttribute('tabindex', '-1');

    function addInert(element) {
      if (element === root || element.hasAttribute('data-nzs-overlay-keep')) return;
      if (!element.hasAttribute('inert')) {
        element.setAttribute('inert', '');
        inerted.push(element);
      }
    }

    function inertAroundRoot(target) {
      var branch = root;
      while (branch && branch !== target) {
        var parent = branch.parentElement;
        if (!parent || !target.contains(parent)) return;
        Array.prototype.forEach.call(parent.children, function (sibling) {
          if (sibling !== branch) addInert(sibling);
        });
        branch = parent;
      }
    }

    function setBackgroundInert() {
      /* Old Safari gets the dynamic focus trap only; descendant tabindex values stay untouched. */
      if (!CAN_INERT) return;
      backgroundTargets().forEach(function (element) {
        if (element.contains(root)) inertAroundRoot(element);
        else addInert(element);
      });
    }

    function clearBackgroundInert() {
      inerted.forEach(function (element) { element.removeAttribute('inert'); });
      inerted = [];
    }

    function lockScroll() {
      if (locked) return;
      locked = true;
      acquireScrollLock();
    }

    function unlockScroll() {
      if (!locked) return;
      locked = false;
      releaseScrollLock();
    }

    function initialFocus() {
      if (!openState) return;
      var active = document.activeElement;
      if (root.contains(active) && isVisible(active)) return;
      var preferred = root.querySelector('[data-nzs-autofocus]');
      var target = preferred && isVisible(preferred) ? preferred : focusables(root)[0];
      focus(target || root);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;

      var items = focusables(root);
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;

      if (!items.length) {
        event.preventDefault();
        focus(root);
      } else if (event.shiftKey && (active === first || !root.contains(active))) {
        event.preventDefault();
        focus(last);
      } else if (!event.shiftKey && (active === last || !root.contains(active))) {
        event.preventDefault();
        focus(first);
      }
    }

    function onPageShow(event) {
      if (!event.persisted) return;
      var wasOpen = openState;
      var restoreFocus = root.contains(document.activeElement);
      openState = false;
      document.removeEventListener('keydown', onKeydown);
      window.removeEventListener('pageshow', onPageShow);
      try {
        if (wasOpen) onClose();
      } finally {
        clearBackgroundInert();
        unlockScroll();
        if (restoreFocus && trigger && trigger.isConnected) focus(trigger);
      }
    }

    /* open({ trigger }) overrides the restore target; close({ restoreFocus: false }) suppresses restoration. */
    function open(openOptions) {
      openOptions = openOptions || {};
      if (openOptions.trigger) trigger = openOptions.trigger;
      if (window.__nzsCloseAllExcept) window.__nzsCloseAllExcept(key);
      if (openState) return;
      openState = true;
      try {
        onOpen();
        document.addEventListener('keydown', onKeydown);
        window.addEventListener('pageshow', onPageShow);
        /* NZS-MNAV-SMOOTH-0903: inert (whole-document style invalidation), the body position:fixed scroll
           lock (forced layout + full reflow) and the focusable scan (~40 getClientRects) used to run in the
           same frame the sheet started sliding. They now wait for the root's own transition to end. */
        var settled = false;
        var settle = function (ev) {
          if (settled || (ev && ev.target && ev.target !== root)) return;
          settled = true;
          root.removeEventListener('transitionend', settle);
          if (!openState) return;
          setBackgroundInert();
          lockScroll();
          initialFocus();
        };
        root.addEventListener('transitionend', settle);
        setTimeout(settle, 450);
      } catch (error) {
        openState = false;
        document.removeEventListener('keydown', onKeydown);
        window.removeEventListener('pageshow', onPageShow);
        clearBackgroundInert();
        unlockScroll();
        try { onClose(); } catch (_) {}
        throw error;
      }
    }

    function close(closeOptions) {
      if (!openState) return;
      closeOptions = closeOptions || {};
      var restoreFocus = closeOptions.restoreFocus !== false && root.contains(document.activeElement);
      openState = false;
      try {
        onClose();
      } finally {
        document.removeEventListener('keydown', onKeydown);
        window.removeEventListener('pageshow', onPageShow);
        clearBackgroundInert();
        unlockScroll();
        if (restoreFocus && trigger && trigger.isConnected) focus(trigger);
      }
    }

    window.__nzsSurfaces = window.__nzsSurfaces || {};
    window.__nzsSurfaces[key] = close;

    return {
      open: open,
      close: close,
      isOpen: function () { return openState; }
    };
  }

  window.nzsOverlay = window.nzsOverlay || {};
  window.nzsOverlay.enhance = enhance;
  window.nzsOverlay.acquireScrollLock = acquireScrollLock;
  window.nzsOverlay.releaseScrollLock = releaseScrollLock;
})(window, document);
